<template>
  	<div>
		<div>
			<el-dialog title="设备策略设置" :visible.sync="dialogFormVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" center>
				<el-form :model="form" :rules="rules" ref="form" :label-width="$store.state.width>$store.state.minwidth?'110px':''" class="demo-ruleForm">
					<el-form-item label="选择设备" prop="equipmentvalue">
						<el-select v-model="form.equipmentvalue" placeholder="请选择设备"  style="width: 95%;">
							<el-option
							  v-for="item in form.equipments"
							  :key="item.value"
							  :label="item.label"
							  :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="表达式" style="width:95%"> 
						<el-input
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 6}"
							placeholder="设置以下下拉菜单自动合成表达式"
							v-model="form.expressionvalue"
							:disabled="true">
						</el-input>
					</el-form-item>
					<div class="moreRules">
						<div class="moreRulesIn" v-for="(item, index) in form.moreNotifyObject" :key="item.key">
							<el-form-item label="" 
								class="demo-form-inline" 
								:prop="'moreNotifyObject.' + index +'.equipment1'" 					
								:rules="{ required: true, message: '请选择', trigger: 'change'}">
								<el-select v-model="item.equipment1"  									
									placeholder="请选择传感器" 
									style="width:36%" 
									@change="forchanges()">
									<el-option 
										v-for="item in form.sensors"
										:key="item.value"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
								<el-select v-model="item.than1" 
									placeholder="请选择..." 
									style="width:16%" 
									@change="forchanges()">
									<el-option label="小于" value="<"></el-option>
									<el-option label="大于" value=">"></el-option>
								</el-select>
								<el-input  v-model="item.value1" :prop="'moreNotifyObject.' + index +'.value1'" placeholder="值" style="width:12%" @input="forchanges()"></el-input>
								<el-select v-if="index!=(form.moreNotifyObject.length-1)" v-model="item.logic" :prop="'moreNotifyObject.' + index +'.logic'" placeholder="请选择..." style="width:16%" @change="forchanges()">
									<el-option label="并且" value="and"></el-option>
									<el-option label="或者" value="or"></el-option>
								</el-select>
								<el-button v-else-if="(form.moreNotifyObject.length-1)<4" type="primary" @click="addUser(index)" icon="el-icon-circle-plus-outline" style="margin:0 0px auto; "  circle></el-button>
								<el-button v-if="index!=(0)" type="danger" icon="el-icon-remove-outline" @click="deleteRules(item, index)" style="float:right ;margin-right:10px;"  circle></el-button>
							</el-form-item>
						</div>
					</div>
					<el-form-item label="策略动作" class="demo-form-inline" prop="sensorsvalue">
						<el-select v-model="form.sensorsvalue"   placeholder="请选择传感器" style="width:40%">
							<el-option 
								v-for="item in form.sensors"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select  v-model="form.sensorsopen"  placeholder="请选择..." style="width:40%">
							<el-option label="关闭" value="shanghai"></el-option>
							<el-option label="打开" value="beijing"></el-option>
						</el-select>
					</el-form-item>
					<div class="moreRules">
						<div class="moreRulesIn" v-for="(item, index) in form.moreNotifyObject1" :key="item.key">
							<el-form-item label="" class="demo-form-inline" :prop="'moreNotifyObject1.' + index +'.date'" :rules="{ required: true, message: '请选择', trigger: 'change'}">
								<el-select v-model="item.date" placeholder="请选择..." style="width:36%" >
									<el-option 
										v-for="item in form.dates"
										:key="item.value"
										:label="item.label"
										:value="item.value" 
										>
									</el-option>
								</el-select>
								<el-time-select
									v-model="value1"
									:picker-options="{
										start: '08:30',
										step: '00:15',
										end: '18:30'
									}"
									placeholder="选择时间">
								</el-time-select>
								<el-button v-show="index===(form.moreNotifyObject1.length-1)" v-if="(form.moreNotifyObject1.length-1)<4" type="primary" @click="addDate(index)" icon="el-icon-circle-plus-outline" style="margin:0 0px auto; "  circle></el-button>
								<el-button v-if="index!=(0)" type="danger" icon="el-icon-remove-outline" @click="deleteDate(item, index)" style="float:right ;margin-right:10px;"  circle></el-button>
							</el-form-item>
						</div>
					</div>
					<el-form-item>
						<el-button type="primary" @click="submitForm('form')">立即创建</el-button>
						<el-button @click="resetForm('form')">重置</el-button>
						<el-button @click="dialogFormVisible = false">取 消</el-button>
					</el-form-item>
				</el-form>
				<el-alert
				  v-if="(form.moreNotifyObject.length-1)>=4"
				  title="不可以添加了哦"
				  type="error"
				  center
				  plain
				  show-icon>
				</el-alert>
				<el-alert
				  v-if="(form.moreNotifyObject1.length-1)>=4"
				  title="不可以添加了哦"
				  type="error"
				  center
				  show-icon>
				</el-alert>
			</el-dialog>
		</div>
  		<div>
			<el-row>
				<el-col :span="24">
					<div class="bread">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>设备策略设置</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<el-row class="top">
				<el-col :span="24">
					<el-button :size="$store.state.width<$store.state.minwidth?'mini':''" type="primary" icon="el-icon-circle-plus-outline" @click="dialogFormVisible = true">新增策略</el-button>
					<el-button :size="$store.state.width<$store.state.minwidth?'mini':''" type="success" icon="el-icon-remove-outline" @click="deleteExpression()">删除策略</el-button>
				</el-col>
			</el-row>
			<el-row class="top">
				<el-col :span="24">
					<div>
						<el-table :size="$store.state.width<$store.state.minwidth?'mini':''" ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width: 100%" stripe @selection-change="handleSelectionChange">
							<el-table-column type="selection"></el-table-column>
							<el-table-column label="启用状态" header-align="center" align="center" width="130">
							  <template slot-scope="scope">
									<el-popover trigger="hover" placement="top">
										<span>{{ scope.row.state }}，点击{{scope.row.state1}}</span>
										<div slot="reference" class="name-wrapper">
											<el-button :size="$store.state.width<$store.state.minwidth?'mini':''" id="" type="info" v-if="scope.row.state === '未开启'" icon="el-icon-warning" @click="changeState(scope.$index)">{{ scope.row.state }}</el-button>
										<el-button :size="$store.state.width<$store.state.minwidth?'mini':''" id="" type="success" v-else icon="el-icon-success" @click="changeState(scope.$index)">{{ scope.row.state }}</el-button>
										</div>
									</el-popover>
								</template>
							</el-table-column>
							<el-table-column
							  prop="expression"
							  label="条件表达式"
							  header-align="center"
							  align="center">
							</el-table-column>
							<el-table-column
							  prop="terminal"
							  label="关联设备终端"
							  header-align="center"
							  align="center"
							  width="200"
							  show-overflow-tooltip>
							</el-table-column>
							<el-table-column					
								label="策略动作"
								width="150"
								align="center">
								<template slot-scope="scope">
									<el-button
										@click.native.prevent="deleteRow(scope.$index, tableData4)"
										type="text"
										size="small">
										设直流电机为【0】
									</el-button>
								</template>
							</el-table-column>
							<el-table-column
							  prop="terminal.value1"				  
							  label="执行时间"
							  align="center"
							  width="250">
								<template slot-scope="scope">
									<el-tag>每日 {{scope.row.value1}}</el-tag>			
								</template>		
							</el-table-column>
							<el-table-column
							  prop="tag"
							  label="创建人"
							  width="100"
							  :filters="[{ text: '公司1', value: '公司1' }, { text: '公司2', value: '公司2' }]"
							  :filter-method="filterTag"
							  filter-placement="bottom-end">
								<template slot-scope="scope">
									<el-tag :type="scope.row.tag === '公司1' ? 'primary' : 'success'" disable-transitions>{{scope.row.tag}}</el-tag>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-col>
			</el-row>
		</div>
  	</div>
</template>

<script>
export default {
  data() {
      return {
        tableData3: [{
					state: '未开启',
					state1: '开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
					creator: '张大嘴',
					tag:'张大嘴',
					value1: '9:10',
		  id: 1
        }, {
					state: '未开启',
					state1: '开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
					creator: '李鸡毛',
					tag:'李鸡毛',
					value1: '9:20',
		  id: 2
        }, {
					state: '启用中',
					state1: '关闭',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
					creator: '王五',
					tag:'王翠花',
					value1: '9:10',
		  id: 3
        }, {
					state: '启用中',
					state1: '关闭',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
					creator: '张四',
					tag:'张芝士',
					value1: '9:10',
		  id: 4
        }, {
					state: '未开启',
					state1: '开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
					creator: '小明',
					tag:'李滕瓜',
					value1: '9:10',
		  id: 5
        }, {
					state: '未开启',
					state1: '开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
					creator: '牛拉粪',
					tag:'牛拉粪',
					value1: '9:10',
		  id: 6
        }, {
					state: '启用中',
					state1: '关闭',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
					creator: '王里钻',
					tag:'王里钻',
					value1: '9:10',
		  id: 7
				}],
				
		multipleSelection: [],
		dialogFormVisible: false,

				form: {
          equipmentvalue: '',
					expressionvalue: '',
					sensorsvalue:'',
					sensorsopen:'',
          equipments: [{
						value: '设备1',
						label: '设备1'
					  }, {
						value: '设备2',
						label: '设备2'
					  }, {
						value: '设备3',
						label: '设备3'
					  }, {
						value: '设备4',
						label: '设备4'
					  }, {
						value: '设备5',
						label: '设备5'
						}],  

					sensors: [{
						value: '电压',
						label: '传感器1'
					  }, {
						value: '温度',
						label: '传感器2'
					  }, {
						value: '压强',
						label: '传感器3'
					  }, {
						value: '浓度',
						label: '传感器4'
					  }, {
						value: '速度',
						label: '传感器5'
					}],

					dates: [{
						value: '每日',
						label: '每日'
					  }, {
						value: '每天',
						label: '每天'
					  }], 

					moreNotifyObject: [{
						equipment1:'',
						equipment2: '',
						than1:'',
						than2:'',
						value1:'',
						value2:'',
						logic:''							
					}],
					moreNotifyObject1: [{
						date:'',
						time: '',							
					}]     

				},
				
				

				rules: {
					equipmentvalue: [
            { required: true, message: '请选择', trigger: 'change' }
					],
					sensorsopen: [
            { required: true, message: '请选择', trigger: 'change' }
					],
				},
				
      }
    },

    methods: {
			changeState(index)
			{
				if(this.tableData3[index]["state"] === "未开启")
				{
					this.tableData3[index]["state"] = "启用中";
					this.tableData3[index]["state1"]="关闭";
				}
				else
				{
					this.tableData3[index]["state"] = "未开启";
					this.tableData3[index]["state1"]="开启";
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			deleteExpression()
			{
				for(var i=0;i<this.multipleSelection.length;i++)
				{
					console.log("删除了："+this.multipleSelection[i]["id"]);
					console.log("删除了："+this.multipleSelection[i]["id"]);
					var wmxzz= this.tableData3.indexOf(this.multipleSelection[i]);
					this.tableData3.splice(wmxzz,1)
				}
			},


			submitForm(formName) {
				console.log(formName)
        this.$refs[formName].validate((valid) => {
          if (valid) {
						
            alert('submit!');
          } else {
						console.log('error submit!!');
						console.log(formName)
            return false;
          }
        });
      },
			
      resetForm(formName) {
        this.$refs[formName].resetFields();
			},
			
			addUser(index) {
				
				if(index<4)
				{
					this.form.moreNotifyObject.push({
						date:'',
						time: '',	
					})
				}
			},
			
			addDate(index) {
				
				if(index<4)
				{
					this.form.moreNotifyObject1.push({
							equipment1:'',
							equipment2: '',
							than1:'',
							than2:'',
							value1:'',
							value2:'',
							logic:''
					})
				}
				else{
					this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
				}
    	},

			deleteRules(item, index) {
				this.index = this.form.moreNotifyObject.indexOf(item)
				if (index !== 0) {
					this.form.moreNotifyObject.splice(index, 1);

				}
			},
			deleteDate(item, index) {
				this.index = this.form.moreNotifyObject1.indexOf(item)
				if (index !== 0) {
					this.form.moreNotifyObject1.splice(index, 1);

				}
			},

			forchanges()
			{
				var str = "";
				for(var i=0;i<this.form.moreNotifyObject.length;i++)
				{
					if(this.form.moreNotifyObject[i]["equipment1"] != "")
					{
						str += ("{" + this.form.moreNotifyObject[i]["equipment1"] + "}");
					}
					if(this.form.moreNotifyObject[i]["than1"] != "")
					{
						str += (this.form.moreNotifyObject[i]["than1"]+ "");
					}
					if(this.form.moreNotifyObject[i]["value1"] != "")
					{
						str += (this.form.moreNotifyObject[i]["value1"]+ " ");
					}
					if(this.form.moreNotifyObject[i]["logic"] != "")
					{
						str += (this.form.moreNotifyObject[i]["logic"]+ " ");
					}
				}
				this.form.expressionvalue = str;
			},

    }
  
}
</script>

<style scoped>
	.top{
		margin-top: 10px;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			padding-left: 5px;
		}
	}
</style>
